import { DishAllergen } from "api-types";

import React from "react";

import { Stack, Typography, useTheme } from "@mui/material";

import { useTranslation } from "../../../i18n";
import { AllergenChipOutlined } from "../../Chip/Chip";
import { useFilterMenu } from "../filters";

interface DishInfoMayContainProps {
  matchedMayContainAllergens: DishAllergen[];
}

export const DishInfoMayContain = ({
  matchedMayContainAllergens,
}: DishInfoMayContainProps) => {
  const {
    palette: { oscar },
  } = useTheme();
  const { t } = useTranslation();
  const filterMenu = useFilterMenu();
  return (
    <Stack
      alignItems="center"
      display="flex"
      borderRadius={4}
      gap={1}
      paddingBottom={2}
      marginTop={1}
      sx={{
        backgroundColor: oscar.light.surface.neutral,
        padding: 4,
        width: "100%",
      }}
    >
      <Typography variant="labelRMedium">{t("dish.mayContain")}</Typography>
      {filterMenu.showMayContainAllergens &&
        !!matchedMayContainAllergens.length && (
          <Stack
            alignItems="center"
            flexDirection="row"
            flexWrap="wrap"
            justifyContent="center"
            gap={1.5}
            paddingTop={1}
          >
            {matchedMayContainAllergens.map((mayContainAllergen) => (
              <AllergenChipOutlined
                mayContain
                key={mayContainAllergen.igfdTaxAllergenId}
                allergenName={
                  mayContainAllergen.isOptional
                    ? t("dish.itemCanBeRemoved", {
                        name: mayContainAllergen.allergenName,
                      })
                    : mayContainAllergen.allergenName
                }
                canOmit={mayContainAllergen.isOptional}
              />
            ))}
          </Stack>
        )}
    </Stack>
  );
};
